<div class=" bg-white p-4  rounded-lg shadow-md">
    <label class="text-[20px] font-semibold mb-4">
     RESPONSE
    </label>
    <div class="text-center flex flex-col items-center">
        <img src="/assets/icons/null_response.svg" alt="No RFI Found" class="w-46 h-46 mx-auto">
        
        <p class="text-lg font-semibold mb-2 roboto">
            There are No Response to Display Right Now
        </p>
        <p class="text-[#000] font-normal text-[1rem] roboto mb-4">
            Once your team created responses, you can view here
        </p>
        <button class="bg-[#FFFFFF] text-[#E76B3F] border border-[#E76B3F] font-semibold px-4 py-2 rounded-[3px]">
            Add Response
        </button>
    </div>
   </div>